import React from 'react';

const HowToPlayModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
          overflowY: 'auto'
        }}
      >
        {/* Modal */}
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: 'white',
            borderRadius: '16px',
            maxWidth: '800px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            position: 'relative',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
          }}
        >
          {/* Header */}
          <div style={{
            padding: '2rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '16px 16px 0 0',
            color: 'white',
            position: 'sticky',
            top: 0,
            zIndex: 10
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 800, margin: 0 }}>
                🎭 How to Play Charades Party
              </h2>
              <button
                onClick={onClose}
                className="btn btn-ghost"
                style={{
                  color: 'white',
                  fontSize: '1.5rem',
                  padding: '0.5rem',
                  minWidth: 'auto',
                  lineHeight: 1
                }}
              >
                ✕
              </button>
            </div>
          </div>

          {/* Content */}
          <div style={{ padding: '2rem' }}>
            {/* Quick Overview */}
            <div style={{
              background: 'linear-gradient(135deg, #667eea10 0%, #764ba210 100%)',
              padding: '1.5rem',
              borderRadius: '12px',
              marginBottom: '2rem'
            }}>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.6, margin: 0 }}>
                <strong>Charades Party</strong> is a real-time multiplayer game where teams compete to act out and guess words.
                One player acts while their team guesses. No talking allowed!
              </p>
            </div>

            {/* Step-by-step Guide */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem', color: '#667eea' }}>
                📖 Step-by-Step Guide
              </h3>

              {/* Step 1 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    1
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      🎮 Create or Join a Game
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      <strong>Host:</strong> Click "Create Game" and share the 6-character code with friends.<br />
                      <strong>Players:</strong> Click "Join Game" and enter the game code.<br />
                      <strong>Minimum 4 players required to start!</strong>
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    2
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      👥 Team Assignment
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      When the host starts the game, players are randomly split into <strong>Team A</strong> and <strong>Team B</strong>.
                      Your team will be displayed on your screen. Teams work together to score points!
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    3
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      🗳️ Word Selection (Team A)
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      <strong>Team A</strong> sees 5 funny words and votes for their favorite.
                      Watch the votes update in real-time! The word with the most votes wins.
                      You can also add custom words if enabled. <em>(30-second timer)</em>
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    4
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      🎯 Performer Selection (Team B)
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      <strong>Team B</strong> selects who will perform the charade.
                      The game suggests the next person based on fair rotation (who performed the least).
                      <em>(25-second timer)</em>
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 5 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    5
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      🎬 Word Reveal & Performance
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '0.75rem' }}>
                      <strong>The Performer:</strong>
                    </p>
                    <ul style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0, paddingLeft: '1.25rem' }}>
                      <li>Sees "You're the Performer!" prompt</li>
                      <li>Places phone face-up on table where they can see it</li>
                      <li>Taps "I'm Ready" to see a 3-2-1 countdown</li>
                      <li>Word appears in GIANT letters</li>
                      <li><strong>Acts out the word WITHOUT talking or making sounds!</strong></li>
                    </ul>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginTop: '0.75rem', marginBottom: '0' }}>
                      <strong>Team B (Guessing Team):</strong> Watches and shouts out guesses!<br />
                      <strong>Team A:</strong> Watches and prepares to score at the end.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 6 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    6
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      ⏱️ The Timer
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      A countdown timer runs while the performer acts (default 60 seconds, set by host).
                      All players see the timer. When time runs out, you'll hear a <strong>BUZZER</strong> sound!
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 7 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    7
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      ✅ Quick-Score
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '0.75rem' }}>
                      When time's up, <strong>Team A</strong> (the word-selecting team) scores:
                    </p>
                    <ul style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0, paddingLeft: '1.25rem' }}>
                      <li><strong>First person to tap</strong> decides: ✓ YES (point awarded) or ❌ NO (no point)</li>
                      <li>3-second undo window - any team member can tap "Undo" to change</li>
                      <li>After 3 seconds, the score is final</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Step 8 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    8
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      🔄 Next Round - Teams Swap!
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      After scoring, teams swap roles:<br />
                      <strong>Team A</strong> becomes the performing/guessing team<br />
                      <strong>Team B</strong> selects the word<br />
                      Keep playing rounds until the host ends the game!
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 9 */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{
                    background: '#667eea',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    flexShrink: 0
                  }}>
                    9
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                      🏆 Game End & Winner
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>
                      When the host ends the game, final scores are tallied.
                      The team with the most points wins! 🎉
                      Watch for <strong>confetti animation</strong> if your team won.
                      Your stats (games played, wins, points, XP) are automatically updated!
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Key Rules */}
            <div style={{
              background: '#fff3cd',
              padding: '1.5rem',
              borderRadius: '12px',
              borderLeft: '4px solid #f59e0b',
              marginBottom: '2rem'
            }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1rem', color: '#f59e0b' }}>
                ⚠️ Key Rules
              </h3>
              <ul style={{ margin: 0, paddingLeft: '1.25rem', lineHeight: 1.8 }}>
                <li><strong>NO TALKING</strong> while performing - only gestures and movements!</li>
                <li><strong>NO SOUNDS</strong> - can't hum, sing, or make noise</li>
                <li><strong>NO MOUTHING</strong> words - lips must stay closed</li>
                <li><strong>NO POINTING</strong> at objects in the room (unless acting it out)</li>
                <li><strong>BE FAIR</strong> when scoring - team must say the exact word</li>
              </ul>
            </div>

            {/* Pro Tips */}
            <div style={{
              background: '#d1fae5',
              padding: '1.5rem',
              borderRadius: '12px',
              borderLeft: '4px solid #10b981',
              marginBottom: '2rem'
            }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1rem', color: '#10b981' }}>
                💡 Pro Tips
              </h3>
              <ul style={{ margin: 0, paddingLeft: '1.25rem', lineHeight: 1.8 }}>
                <li><strong>Best with 6-8 players</strong> - Perfect balance of fun and chaos</li>
                <li><strong>Use your whole body</strong> - Big, expressive movements are easier to guess</li>
                <li><strong>Break words into syllables</strong> - Act out "sun" + "flower" for "sunflower"</li>
                <li><strong>Use the undo button</strong> - Made a mistake scoring? You have 3 seconds!</li>
                <li><strong>Enable custom words</strong> - Add inside jokes for hilarious moments</li>
              </ul>
            </div>

            {/* Footer CTA */}
            <div style={{ textAlign: 'center' }}>
              <button
                onClick={onClose}
                className="btn btn-lg"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontSize: '1.125rem'
                }}
              >
                Got It! Let's Play 🎮
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowToPlayModal;
